import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';

import Grid from '@mui/joy/Grid';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import useUserIdentity from 'hooks/useUserIdentity';
import useChatRoom from 'hooks/useChatRoom';

import { ChatRoomType } from 'stores/chat_room_store';
// import ChatBody from 'components/ChatBody';
import ChatSidebar from 'components/ChatSidebar';
import AssistantOnly from 'components/AssistantOnly';
import ChatRoomCreate from './ChatRoomCreate';
import LoadingSection from './LoadingSection';
import useWorkKey from 'hooks/useWorkKey';


const ChatContainer = observer(() => {

    const { currentIdentity } = useUserIdentity();
    const { fetchList, items } = useChatRoom();
    const [fetched, setFetched] = useState(false);
    const workKey = useWorkKey();
    const [rooms, setRooms] = useState([] as ChatRoomType[]);

    useEffect(() => {
        if(!currentIdentity?.team) return;
        fetchList(currentIdentity.uuid)
            .then((rms) => {
                setRooms(rms);
            })
            .catch((err) => {
                console.error(err);
            })
        .finally(() => {
            setFetched(true);
        });
    }, [currentIdentity?.team, workKey]);

    useEffect(() => {
        if(!currentIdentity?.team) return;
        console.log("Number of changed");
        setRooms(items);
    }, [items.length, currentIdentity?.team]);

      useEffect(() => {
        document.title = "@Chat";
    }, []);

    if(!currentIdentity || !fetched) {
        return <LoadingSection />;
    }
    if(!currentIdentity?.team) {
        return (
            <Stack>You need to be on a team to use chat</Stack>
        );
    }



    return (
        <AssistantOnly allowClient={true}>
        <Grid container spacing={2}>
            <Grid xs={12} sm={8}>
                {(fetched && !rooms.length) ?
                    <Stack m={1}>
                        <Typography level="title-md">No chat rooms found</Typography>
                        <ChatRoomCreate defaultName="General 💼" defaultDescription="Work related chat" />
                    </Stack>
                    :
                    <Outlet />
                }
            </Grid>
            <Grid xs={12} sm={4}>
                <Stack
                    sx={{
                        zIndex: 850,
                        //backgroundColor: theme.vars.palette.background.surface,
                        overflow: 'auto',
                        position: { xs: undefined, sm: 'sticky' },
                        top: { xs: undefined, sm: `var(--TopperHeight)` },
                    }}
                >
                    <ChatSidebar rooms={rooms} />
                </Stack>
            </Grid>
        </Grid>
        </AssistantOnly>
    );
});
export default ChatContainer;
